import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Close as CloseIcon } from '@material-ui/icons';
import { ClickAwayListener, Dialog as MaterialDialog, Portal } from '@material-ui/core';
import { ElasticTheme } from '@dev/ee-components';
import { CloseVideoOverlay, getOnboardingStore } from '@/store/onboarding/actions';
import { CloseIconContainer, Overlay, StyledIframe, VideoOverlayWrapper } from './styles';

const onboardingVideoOverlayContainerId = 'onboardingVideoOverlay';
const iframeTitle = 'YouTube video player';
const allowedIframePermissions = 'clipboard-write; encrypted-media; gyroscope; picture-in-picture';
const backgroundColor = 'rgba(45, 47, 122, 0.6)';

const getIframeSrc = (videoId: string) => `https://www.youtube.com/embed/${videoId}`;

export const OnboardingVideogOverlay = () => {
    const dispatch = useDispatch();
    const { openVideo } = useSelector(getOnboardingStore);
    const close = () => {
        dispatch(CloseVideoOverlay());
    };

    return (
        <Portal>
            <MaterialDialog
                open={!!openVideo}
                fullScreen
                scroll="body"
                id={onboardingVideoOverlayContainerId}
                style={{ zIndex: ElasticTheme.zIndex.tooltip + 1 }}
                PaperProps={{ style: { backgroundColor } }}
            >
                <Overlay>
                    <CloseIconContainer>
                        <CloseIcon fontSize="medium" onClick={close} />
                    </CloseIconContainer>
                    <VideoOverlayWrapper>
                        <ClickAwayListener onClickAway={close}>
                            <StyledIframe
                                src={getIframeSrc(openVideo)}
                                title={iframeTitle}
                                allow={allowedIframePermissions}
                                allowFullScreen
                            />
                        </ClickAwayListener>
                    </VideoOverlayWrapper>
                </Overlay>
            </MaterialDialog>
        </Portal>
    );
};
